// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {};

	SearchInput.prototype.afterBindEvents = function() {
		// Fix cannot close search suggestion when clicking overlay 
		document.addEventListener('click', function(e) {
			if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
				var $clickedElement = jQ(e.target);
				var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
				if (isClickSuggestion) {
					this.searchAutoComplete.$element.hide();
					this.searchAutoComplete.searchInput.onCloseAutocomplete();
					this.searchAutoComplete.isOpen = false;
				}
			}
		}.bind(this), true);
	}

  InstantSearchResultBlock.prototype.getTemplate = function (tempType) {
      switch (tempType) {
          case 'dym':
              return `
                  <li class="{{class.searchSuggestionItem}} {{class.searchSuggestion}}-dym" aria-label="Did you mean">{{dymContent}}</li>
              `.trim();
          default:
              return `
                  <div class="{{class.searchSuggestionGroup}}" data-group="{{type}}" aria-label="{{label}}">
                      <ul>
                          <li class="{{class.searchSuggestionHeader}}-{{type}} {{class.searchSuggestionHeader}}" aria-label="{{label}}"><h2 class="pfs--heading">{{label}}</h2></li>
                          {{resultItems}}
                      </ul>
                  </div>
              `.trim();
      }
  }
  InstantSearchResultItemCollection.prototype.getTemplate = function () {
      return `
          <li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedDataTitle}}" role="option">
              <a tabindex="-1" href="{{searchLink}}"><h3 class="pfs--item">{{highlightedSuggestionResult}}</h3></a>
          </li>
      `.trim();
  }
  InstantSearchResultItemPage.prototype.getTemplate = function() {
      return `
          <li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedDataTitle}}" role="option">
              <a tabindex="-1" href="{{searchLink}}"><h3 class="pfs--item">{{highlightedSuggestionResult}}</h3></a>
          </li>
      `.trim();
  }
  InstantSearchResultItemPopular.prototype.getTemplate = function() {
      return `
          <li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedData}}" role="option">
              <a tabindex="-1" href="{{searchLink}}"><h3 class="pfs--item">{{highlightedSuggestionResult}}</h3></a>
          </li>
      `.trim();
  }
  InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
      switch (tempType) {
          case InstantSearchResultItemProduct.tempType.IMAGE:
              return `
                  <div class="{{class.searchSuggestion}}-left">
                      <img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
                  </div>
              `.trim();
          case InstantSearchResultItemProduct.tempType.SKU:
              return `
                  <p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
              `.trim();
          case InstantSearchResultItemProduct.tempType.VENDOR:
              return `
                  <p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
              `.trim();
          case InstantSearchResultItemProduct.tempType.PRICE:
              return `
                  <p class="{{class.searchSuggestion}}-product-price">
                      <span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
                  </p>
              `.trim();
          case InstantSearchResultItemProduct.tempType.PRICE_SALE:
              return `
                  <p class="{{class.searchSuggestion}}-product-price">
          <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;
                      <s>{{compareAtPrice}}</s>
                      
                  </p>
              `.trim();
          default:
              return `
                  <li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
                      <a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
                          {{itemProductImage}}
                          <div class="{{class.searchSuggestion}}-right">
                              <h3 class="pfs--item {{class.searchSuggestion}}-product-title">{{title}}</h3>
                              {{itemProductSku}}
                              {{itemProductVendor}}
                              {{itemProductPrice}}
                          </div>
                      </a>
                  </li>
              `.trim();
      }
  }
})();